import React from "react";
import {useCustomerNavigationItems} from "../../../../Utils/navigationItemsHelper";
import VerticalNavigationBarItem from "../../../Navigation/VerticalNavigationBarItem";
import modals from "../../../../Constants/modals";
import LeadSendEmailModal from "../../../Customer/Modals/LeadSendEmailModal";
import useModal from "../../../../Hooks/useModal";
import CheckAddressModal from "../../../Customer/CheckAddressModal";
import {useSelector} from "react-redux";

const CustomerMenuItems = () => {
    const { isModalOpen, closeModal } = useModal();

    const customer = useSelector((state) => state.CustomerReducer.customer);
    const updatedInfo = useSelector((state) =>  state.CommonReducer.forms && state.CommonReducer.forms.updateCustomerForm);
    const items = useCustomerNavigationItems();
    
    return (
        <>
            {items.map((item, index) => {
                return <VerticalNavigationBarItem key={index} link={item.link} disabled={item.disabled} badgeNumber={item.badgeNumber}/>
            })}
            {isModalOpen(modals.SendLeads) && <LeadSendEmailModal onClose={closeModal} />}
            <CheckAddressModal customer={customer} updatedInfo={updatedInfo} />
        </>
    );
}

export default CustomerMenuItems;